import api from "PFCore/api";
import { Id, MetaWithPagination } from "PFTypes";
import { CustomValueImport } from "PFTypes";

export type CustomValuesImportsResponse = {
  entries: CustomValueImport[];
  meta: MetaWithPagination;
};

export type CustomValuesImportsParams = {
  search?: string;
  order?: { direction: string } | null;
  page: number;
  perPage: number;
};

export const fetchCustomValuesImports = (
  customTypeId: Id,
  params?: CustomValuesImportsParams
): Promise<CustomValuesImportsResponse> =>
  api({ url: `admin/custom_values/imports`, params: { ...params, customTypeId } });
